import { render } from "./AuthorInfoBlock.vue?vue&type=template&id=17c698b8&scoped=true"
import script from "./AuthorInfoBlock.vue?vue&type=script&lang=js"
export * from "./AuthorInfoBlock.vue?vue&type=script&lang=js"

import "./AuthorInfoBlock.vue?vue&type=style&index=0&id=17c698b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c698b8"]])

export default __exports__